import React from 'react';
import PropTypes from 'prop-types';
import s from './AppCta.module.css';
import { Language, rawString } from '../../react-components/Language';
import { connect } from 'react-redux';
import { ReturnMethods } from '../../constants/enums';
import { logData } from '../../actions/analytics';
import { EVENT_VALUES, EVENTS } from '../../constants/noflake/noflakeSchema';

const associatedMethods = [
  ReturnMethods.Mail,
  ReturnMethods.PrinterlessMail,
  ReturnMethods.Boxless,
  ReturnMethods.Store,
  ReturnMethods.Self,
];
const mapStateToProps = ({
  appCta,
  returnSubmission: {
    returnProcessInfo: { return_method: selectedMethod },
  },
}) => ({
  appCta,
  selectedMethod,
});

const AppCtaComponent = ({ appCta, selectedMethod, dispatch }) => {
  if (
    !appCta?.enabled ||
    !(appCta?.associatedMethods || associatedMethods).includes(selectedMethod)
  )
    return null;

  const appStoreLink = rawString({
    content: appCta?.appStoreLink,
    langKey: 'narvar_app_cta.appStoreLink',
  });

  const googlePlayLink = rawString({
    content: appCta?.googlePlayLink,
    langKey: 'narvar_app_cta.googlePlayLink',
  });

  if (!appStoreLink && !googlePlayLink) return null;

  dispatch(
    logData({
      type: EVENTS.VIEW,
      value: EVENT_VALUES[EVENTS.VIEW].app_store_cta,
    }),
  );

  return (
    <>
      {appCta?.css && (
        <div dangerouslySetInnerHTML={{ __html: `<style>${appCta.css}</style>` }}></div>
      )}
      <div className={s.wrapper}>
        <div className={s.header}>
          {appCta?.iconSrc ? (
            <img className={s.icon} alt="" src={appCta.iconSrc} role="img" />
          ) : (
            <img className={s.icon} alt="" src={'/r2/img/cta/appicon.svg'} role="img" />
          )}
          {appCta?.title && (
            <Language
              tagName="h2"
              content={appCta.title}
              langKey="narvar_app_cta.title"
              className={s.title}
            />
          )}

          {appCta?.subtitle && (
            <Language
              tagName="h3"
              content={appCta.subtitle}
              langKey="narvar_app_cta.subtitle"
              className={s.subtitle}
            />
          )}
        </div>
        <div className={s.appstoreLinks}>
          {appStoreLink && (
            <a
              href={appStoreLink}
              className={s.link}
              target="_blank"
              onClick={() =>
                dispatch(
                  logData({
                    type: EVENTS.CLICK,
                    value: EVENT_VALUES[EVENTS.CLICK].app_store_cta_apple,
                  }),
                )
              }
            >
              <img alt="" src={'/r2/img/cta/apple.svg'} role="img" />
            </a>
          )}
          {googlePlayLink && (
            <a
              href={googlePlayLink}
              className={s.link}
              target="_blank"
              onClick={() =>
                dispatch(
                  logData({
                    type: EVENTS.CLICK,
                    value: EVENT_VALUES[EVENTS.CLICK].app_store_cta_google,
                  }),
                )
              }
            >
              <img alt="" src={'/r2/img/cta/googleplay.svg'} role="img" />
            </a>
          )}
        </div>
      </div>
    </>
  );
};

export const AppCta = connect(mapStateToProps)(AppCtaComponent);

AppCtaComponent.propTypes = {
  appCta: PropTypes.shape({
    enabled: PropTypes.bool,
    appStoreLink: PropTypes.string,
    googlePlayLink: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    associatedMethods: PropTypes.arrayOf(PropTypes.string),
    iconSrc: PropTypes.string,
    css: PropTypes.string,
  }),
};
